import React from 'react'
import { SpinnerWrapper } from '../../../../common/SpinnerWrapper'
import { CanNotDeleteAccount } from '../CanNotDeleteAccount'
import { DeleteAccountStage } from '../DeleteAccountModal'
import { FirstStep } from './FirstStep'
import { LastStep } from './LastStep'
import { SecondStep } from './SecondStep'
import { ISocietiesModel } from '../../../../../interfaces/models/societies.interfaces'

interface DeleteAccountModalContentProps {
  stage: DeleteAccountStage
  loading: boolean
  societiesPreventingAccountDeletion: ISocietiesModel[]
  onChangePassword: (confirmedPassword: string) => void
  password: string
}

export const DeleteAccountModalContent = ({
  stage,
  loading,
  societiesPreventingAccountDeletion,
  onChangePassword,
  password,
}: DeleteAccountModalContentProps): React.ReactNode => {
  if (societiesPreventingAccountDeletion.length > 0) {
    return (
      <CanNotDeleteAccount
        societiesPreventingAccountDeletion={societiesPreventingAccountDeletion}
      />
    )
  }

  if (loading) {
    return <SpinnerWrapper />
  }

  switch (stage) {
    case DeleteAccountStage.SECOND:
      return <SecondStep />
    case DeleteAccountStage.LAST:
      return (
        <LastStep onChangePassword={onChangePassword} password={password} />
      )
    default:
      return <FirstStep />
  }
}
